import { Form, Formik, FormikProps } from 'formik';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BackLogsPanel } from '../../../backen-logs/components/back-logs-panel';

import { SettingsFlowerMailForm } from './flowers-mail';
import { SettingsTabs } from './settings-tabs';
import { SettingsTabOptions } from './settings-tabs/SettingsTabOptions';
import { ISettingsForm } from './types';
import { SettingsWhatsappForm } from './whatsapp';
import Button from 'components/base/Button';
import { SimpleUserRequestPermissionNames } from 'config/apiFunus/generated/data-contracts';
import { useValidator } from 'hooks/useValidator';
import { IFunusSettings } from 'modules/settings/models/IFunusSettings';
import { usePermissions } from 'utils/usePermissions';
import './index.scss';

export const SettingsForm: FC<ISettingsForm> = ({ onSubmit, value, onChange }) => {
  const { t } = useTranslation();
  const { validateSettings } = useValidator();
  const { hasPermission } = usePermissions();

  const [
    selectedTab,
    setSelectedtab,
  ] = useState<SettingsTabOptions>();

  return (
    <div className="form-page f-settings-form">
      <Formik
        initialValues={{
          ...value,
        }}
        validate={((values) => {
          onChange(values);
          return validateSettings(values);
        })}
        enableReinitialize
        validateOnBlur
        validateOnChange
        onSubmit={onSubmit}
      >
        {({
          values,
          handleBlur,
          setValues,
          errors,
          isValid,
        }: FormikProps<IFunusSettings>) => (
          <Form autoComplete="off" className="form-generator">
            <SettingsTabs
              value={selectedTab}
              onChange={(tab: SettingsTabOptions) => setSelectedtab(tab)}
            />
            {hasPermission(SimpleUserRequestPermissionNames.WHATSAPP_SETTINGS)
                && selectedTab === SimpleUserRequestPermissionNames.WHATSAPP_SETTINGS
                && (
                  <SettingsWhatsappForm
                    errors={errors}
                    handleBlur={handleBlur}
                    value={values.whatsapp}
                    onChange={(v) => {
                      setValues({
                        ...values,
                        whatsapp: v,
                      });
                    }}
                  />
                )}
            {hasPermission(SimpleUserRequestPermissionNames.FLOWERS_MAIL_SETTINGS)
                && selectedTab === SimpleUserRequestPermissionNames.FLOWERS_MAIL_SETTINGS
                && (
                  <SettingsFlowerMailForm
                    errors={errors}
                    handleBlur={handleBlur}
                    value={values.flowersMail}
                    onChange={(v) => {
                      setValues({
                        ...values,
                        flowersMail: v,
                      });
                    }}
                  />
                )}
            {hasPermission(SimpleUserRequestPermissionNames.BACK_LOGS)
                && selectedTab === SimpleUserRequestPermissionNames.BACK_LOGS
                && (
                  <BackLogsPanel />
                )}
            <div className="buttons-panel">
              <Button
                color="primary"
                disabled={!isValid}
                text={t('common.save')}
                type="submit"
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
